import jwtDecode from "jwt-decode";

export const hasExpiredToken = (token) => {
  if (typeof token !== "string" || token.trim() === "" || !token.includes(".")) {
    return true;
  }

  try {
    const { exp } = jwtDecode(token);

    if (typeof exp !== "number") {
      return true;
    }

    const currentDate = Date.now();
    return exp * 1000 <= currentDate;
  } catch (error) {
    return true;
  }
};
